import { render, staticRenderFns } from "./favorite.vue?vue&type=template&id=ee2697ee&scoped=true"
import script from "./favorite.vue?vue&type=script&lang=js"
export * from "./favorite.vue?vue&type=script&lang=js"
import style0 from "./favorite.vue?vue&type=style&index=0&id=ee2697ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2697ee",
  null
  
)

export default component.exports